import { makeTable } from "../utils/tables";

export const personalTrinkets = makeTable("personalTrinkets", [
  "Tool with personal inscriptions.",
  "Cartridge with AI from a dead pet.",
  "Embroidered patch from a famous organization.",
  "Memory disk with a loved one’s memories on it.",
  "Weatherproof notebook filled with strange writing and symbols.",
  "Notebook with names of people that have treated you badly.",
  "A bag of metal pieces called coins.",
  "Small toy figurine depicting yourself.",
  "Shades, dirty and scratched after an old job.",
  "A letter from someone you love.",
  "Glove from a stolen prototype space suit.",
  "Ancient necklace inscribed with the letters “USB”.",
  "Music box from your childhood with a holographic swirling galaxy.",
  "A laser disc with your favorite music.",
  "Two glowing wedding rings.",
  "Digital travel brochure for exotic locations with a cracked speaker playing commercial messages.",
  "Ancient synthesizer shaped like a gun.",
  "Holographic image of someone you lost.",
  "Belt buckle with hidden star compass. Only works sometimes, speaker playing commercial messages.",
  "DNA birth certificate circuit.",
]);
